"use client";
import { cleanString } from "@packages/ui/hoc";
import {
  Grid,
  styled,
  Tab,
  Tabs,
  useMediaQuery,
  VeBox,
} from "@packages/ui/mui";
import * as React from "react";
import "./style.scss";
import { useEffect } from "react";

const StyledTabs = styled(Tabs)(() => ({
  "&.MuiTabs-root": {
    paddingBottom: "0 !important",
    minHeight: "36px !important",
  },

  "& .MuiTab-root": {
    textTransform: "inherit",
    fontFamily: "var(--font-inter)",
    fontSize: "14px",
    fontWeight: 600,
    // paddingTop: "24px !important",
    padding: "8px 16px !important",
  },
  "& .Mui-selected": {
    color: "var(--vc-violet) !important",
  },
  "& .MuiTab-root:hover": { color: "var(--vc-violet) !important" },
  "& .MuiButtonBase-root": {
    minHeight: "auto",
  },
}));

interface TabData {
  label: string;
  disabled?: boolean;
  component?: any;
  paddingLeft?: number;
  paddingRight?: number;
}

interface ENTabsProps {
  data: TabData[];
  nextPage: number;
  setNextPage: (page: number) => void;
  rightNode?: React.ReactNode;
  borderRadius?: boolean;
  outerSX?: React.CSSProperties;
  onClickAction?: any;
}

export function ApplicationFormTabs({
  data,
  nextPage,
  setNextPage,
  rightNode,
  onClickAction,
}: ENTabsProps) {
  const [value, setValue] = React.useState(nextPage);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const ref = React.useRef<HTMLDivElement>(null);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    if (onClickAction) {
      onClickAction(newValue);
    }
    setValue(newValue);
  };

  useEffect(() => {
    setValue(nextPage);
  }, [nextPage]);

  useEffect(() => {
    if (setNextPage) setNextPage(value);
  }, [value]);

  return (
    <VeBox
      sx={{
        width: "100%",
      }}
    >
      <VeBox>
        <Grid
          sx={{ display: "flex", justifyContent: "space-between" }}
          container
          ref={ref}
        >
          <Grid item md={12}>
            <VeBox
              sx={{
                borderBottom: "1px solid #E8E8E8",
                width: "max-content",
                maxWidth: isMobile ? ref?.current?.offsetWidth! - 10 : "100%",
              }}
            >
              <StyledTabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons={false}
                aria-label="wrapped label tabs example"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: "var(--vc-violet)",
                  },
                }}
                sx={{
                  button: {
                    maxWidth: "240px",
                  },
                }}
                // className={classes.tabs}
              >
                {data.map((tabLabel: any, index) => (
                  <Tab
                    key={tabLabel.label}
                    label={cleanString(tabLabel.label)}
                    disabled={tabLabel.disabled}
                    wrapped
                    icon={
                      tabLabel?.questionsLeft > 0 ? (
                        <span className={"errorDotSection"} />
                      ) : (
                        <span />
                      )
                    }
                    iconPosition="end"
                    aria-controls={`simple-tabpanel-${index}`}
                    // className={classes.tab}
                  />
                ))}
              </StyledTabs>
            </VeBox>
          </Grid>
          {rightNode}
        </Grid>
      </VeBox>
    </VeBox>
  );
}
